"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const material_1 = require("@mui/material");
const Box_1 = tslib_1.__importDefault(require("@mui/material/Box"));
const Button_1 = tslib_1.__importDefault(require("@mui/material/Button"));
const Popover_1 = tslib_1.__importDefault(require("@mui/material/Popover"));
const FilterBoxLabel_1 = tslib_1.__importDefault(require("./FilterBoxLabel"));
/**
 * This component extends {@link @mui/material.Popover}.
 */
const FilterBox = (props) => {
    const { label, state, onClick, children, disablePadding, fullWidth, ButtonComponent = Button_1.default, ButtonComponentProps = {}, LabelComponent = FilterBoxLabel_1.default, LabelComponentProps = {}, PaperProps = {}, ...popoverProps } = props;
    const theme = (0, material_1.useTheme)();
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(ButtonComponent, { variant: "contained", onClick: onClick, style: {
                height: theme.spacing(6),
                backgroundColor: state === "error"
                    ? theme.palette.error.main
                    : state === "active"
                        ? theme.palette.primary.main
                        : theme.palette.common.white,
            }, ...ButtonComponentProps },
            react_1.default.createElement(Box_1.default, { sx: {
                    alignItems: "center",
                    display: "flex",
                    flexDirection: "row",
                } },
                react_1.default.createElement(LabelComponent, { ...LabelComponentProps }, label))),
        react_1.default.createElement(Popover_1.default, { PaperProps: {
                ...PaperProps,
                sx: Object.assign({
                    display: "flex",
                    flexDirection: "column",
                    // ref https://material.io/design/components/menus.html#specs
                    minWidth: 112,
                    p: disablePadding ? 0 : theme.spacing(3, 3, 1),
                }, !fullWidth && { maxWidth: 320 }),
            }, "data-testid": "popover", transitionDuration: 0, ...popoverProps }, children)));
};
exports.default = FilterBox;
